import { AntdIcons, CustomIcons, IconNames, Icons } from '@common';
import type { ReactElement } from 'react';

export const IconNamesMaps = {
  more: 'EllipsisOutlined',
  refresh: 'SyncOutlined',
  ...CustomIcons,
  ...AntdIcons
};

export function Icon(props: { name?: string | ReactElement }): ReactElement {
  if (props.name == null) {
    return <></>;
  }
  const mapping: Record<string, IconNames> = {
    more: 'EllipsisOutlined',
    refresh: 'SyncOutlined',
    time: 'ClockCircleFilled'
  };

  if (typeof props.name === 'string' && Object.keys(mapping).includes(props.name)) {
    return <Icons name={mapping[props.name]} />;
  }

  if (typeof props.name === 'string' && Object.keys(IconNamesMaps).includes(props.name)) {
    return <Icons name={props.name as IconNames} />;
  }

  return (<>{props.name}</>);
}
